import { Box, Container, Stack, Text, HStack, Link, Divider } from "@chakra-ui/react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <Box bg="black" color="gray.200" py={10} mt={16}>
      <Container maxW="container.xl">
        <Stack spacing={6} align="center">
          {/* Logo / Brand */}
          <Text fontSize="2xl" fontWeight="bold">
            {t("brand")}
          </Text>
          <Divider bg={"white"} w={"20"} />

          {/* Navigation */}
          <HStack spacing={2} fontSize="sm" fontWeight="medium">
            <Text
              _hover={{ color: "orange.400" }}
              as="button"
              onClick={() => document.getElementById("home").scrollIntoView({ behavior: "smooth" })}
            >
              {t("home")}
            </Text>
            <Text
              _hover={{ color: "orange.400" }}
              as="button"
              onClick={() => document.getElementById("about").scrollIntoView({ behavior: "smooth" })}
            >
              {t("about")}
            </Text>
            <Text
              _hover={{ color: "orange.400" }}
              as="button"
              onClick={() => document.getElementById("events").scrollIntoView({ behavior: "smooth" })}
            >
              {t("events")}
            </Text>
            <Text
              _hover={{ color: "orange.400" }}
              as="button"
              onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })}
            >
              {t("contact")}
            </Text>
            <Text
              _hover={{ color: "orange.400" }}
              as="button"
              onClick={() => document.getElementById("team").scrollIntoView({ behavior: "smooth" })}
            >
              {t("team")}
            </Text>
          </HStack>

          {/* Social Icons */}
          <HStack spacing={4}>
            <Link href="https://www.facebook.com/p/Arena-Sports-Center-100063641859855/?locale=el_GR" isExternal
              _hover={{ color: "blue.400" }}>
              <FaFacebook size={20} />
            </Link>
            <Link href="https://www.instagram.com/arenabowlingpatras/?hl=el" isExternal
              _hover={{ color: "red.600" }}>
              <FaInstagram size={20} />
            </Link>
          </HStack>

          {/* Copyright */}
          <Text fontSize="xs" color="gray.500">
            {t("copyright", { year: new Date().getFullYear() })}
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
